import { getTenantClient } from '@sazeo/supabase-tenant';

export const tenantSdkClient = getTenantClient();
